import { useAuth } from "./Auth";
import type { ObsessLessUser } from "../../types/obsessless-user";

export const useLoggedInUser = (): ObsessLessUser => {
    const { authStatus, readyUser } = useAuth();
    if (authStatus !== 'authenticated-ready' || !readyUser) {
        throw new Error("No authenticated user found");
    }
    return readyUser;
};